export default {
  General: {
    Email: "E-mail",
    Send: "Enviar",
    Done: "Concluído",
    Finish: "Concluir",
    Try_again: "Tentar novamente",
    or: "ou"
  },
  SamsungType: {
    bixby: "Com Bixby",
    no_bixby: "Sem Bixby",
    home_button: "Com o botão Início"
  },
  sendEmail: {
    repair_tip1: "Este modelo não pode ser reparado com o aplicativo móvel. Enviaremos a solução de desktop por e-mail.",
    check_tip1: "A verificação do dispositivo não pode ser concluída somente pelo app móvel. Enviaremos a solução para desktop por e-mail.",
    tip1: "Este modelo não pode ser desbloqueado com o aplicativo móvel. Enviaremos a solução de desktop por e-mail.",
    tip2: "Para obter uma melhor taxa de sucesso, conecte o telefone ao computador com um cabo de dados.",
    enter_address: "Insira seu endereço de e-mail.",
    enter_correct_address: "Por favor, insira o endereço de e-mail correto.",
    confidential: "Seu endereço de e-mail será mantido confidencialmente.",
    open_link: "Abra {0} em qualquer navegador de computador para baixar o Dr.Fone.",
    has_sent: "Seu e-mail foi enviado",
    almost: "Quase lá",
    step1: "Etapa 1",
    open_email: "Abra o e-mail em seu computador e use o link enviado para fazer o download da versão desktop do Dr.Fone.",
    step2: "Etapa 2",
    repair_launch_tip: "Inicie o Dr.Fone System Repair e faça login na sua conta para utilizar a função de reparo.",
    check_launch_tip: "Instale a versão para desktop do Dr.Fone e faça login com a mesma conta. Clique em \"My Device\" e siga as instruções na tela para conectar seu dispositivo. Depois de conectado, clique em \"Device Detail\" para ver os resultados detalhados da verificação.",
    launch_tip: "Inicie o Dr.Fone Desbloqueio e faça login em sua conta para usar o recurso de desbloqueio.",
    contact_us: "Entre em contato conosco para obter ajuda."
  },
  Unlock: {
    recoveryMode: "Coloque seu dispositivo no Modo de recuperação",
    wipe_cache: "Limpe a partição de cache no dispositivo",
    wipe_data: "Siga as instruções para apagar dados no dispositivo",
    completed: "Desbloqueio concluído",
    completed_tip: "Verifique se o bloqueio de tela foi removido do dispositivo com sucesso. Se houver falha, tente novamente.",
    contact_us: "Falha ao desbloquear? Entre em contato conosco para obter mais ajuda."
  },
  UnlockStep: {
    sa1: "1. Desligue o telefone e mantenha-o conectado ao computador ",
    sa2: "2. Pressione e mantenha pressionado o botão Aumentar volume + Bixby + Liga/Desliga ao mesmo tempo",
    sa3: "3. Solte as teclas depois que o logotipo da Samsung aparecer e aguarde alguns segundos",
    sa4: "4. Agora, seu dispositivo deve ser inicializado no modo de recuperação. Escolha a opção \"Reinicializar no carregador de inicialização\" para entrar no modo de download.",
    sb1: "1. Desligue o telefone e mantenha-o conectado ao computador",
    sb2: "2. Mantenha pressionado o botão Liga/Desliga e Aumentar o volume ao mesmo tempo",
    sb3: "3. E continue pressionando esses dois botões mesmo depois que o dispositivo iniciar o backup",
    sb4: "4. Agora, seu dispositivo deve ser inicializado no modo de recuperação. Escolha a opção \"Reinicializar no carregador de inicialização\" para entrar no modo de download.",
    sc1: "1. Desligue o telefone e mantenha-o conectado ao computador",
    sc2: "2. Pressione e mantenha pressionado o botão Aumentar volume + Início + Liga/Desliga ao mesmo tempo",
    sc3: "3. Solte as teclas depois que o logotipo da Samsung aparecer e aguarde alguns segundos",
    sc4: "4. Agora, seu dispositivo deve ser inicializado no modo de recuperação. Escolha a opção \"Reinicializar no carregador de inicialização\" para entrar no modo de download.",
    s5: "5. Pressione o botão Volume para selecionar \"Limpar dados/restaurar padrões\" e pressione o botão Liga/Desliga para confirmar",
    s6: "6. Pressione o botão Volume para selecionar \"Sim\" e, em seguida, pressione o botão Liga/Desliga para confirmar",
    s7: "7. Pressione \"Limpar partição de cache\" e selecione \"Sim\"",
    s8: "8. Selecione \"reinicializar sistema agora\" e pressione o botão Liga/Desliga para confirmar. Levará algum tempo para que o dispositivo seja reinicializado.",
    common1: "Desligue o telefone.",
    common2: "Pressione a tecla aumentar volume e Liga/Desliga por alguns segundos.",
    common3: "Solte todas as teclas quando o Modo de recuperação aparecer na tela.",
    m4: "Escolha \"Apagar dados\" usando as teclas de volume e o botão Liga/Desliga para aceitar.",
    m5: "Escolha \"Limpar todos os dados\".",
    m6: "Agora, escolha \"Confirmar\" e aguarde até que o processo termine.",
    m7: "Volte ao Menu principal com a tecla Liga/Desliga.",
    m8: "Selecione \"Reinicializar\".",
    m9: "Por fim, escolha \"Reiniciar no sistema\".",
    h4: "Escolha \"Limpar dados\" usando as teclas de volume e o botão Liga/Desliga para aceitar.",
    h5: "Selecione \"Redefinição de fábrica\".",
    h6: "Digite a palavra \"sim\" e selecione \"Redefinição de fábrica\".",
    h7: "Durante esta operação, todos os seus arquivos serão removidos.",
    h8: "Selecione \"Voltar\" para voltar ao Menu principal.",
    h9: "Por fim, escolha \"Reiniciar\"."
  }
};
